import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    logoBackgroundColor: '#d0d0d0',
    actionButton: {
        backgroundColor: '#808080',
        disabledBackgroundColor: '#606060',
        disabledIconColor: '#606060'
    },
    baseline: {
        background1: '#101010',
        background2: '#202020'
    },
    palette: {
        type: 'dark',
        iconColor: '#FFFFFF',
        backgroundColor: '#404040',
        primary: {
            main: "#4287f5"
        },
        secondary: {
            main: '#57A9C9'
        },
        text: {
            primary: '#ffffff',
            secondary: '#BBBBBB',
            disabled: '#808080'
        }
    },
    overrides: {
        MuiList: {
            root: {
                backgroundColor: '#404040'
            }
        },
        MuiGrid: {
            root: {
                color: '#FFFFFF'
            }
        },
        MuiTab: {
            textColorInherit: {
                color: '#FFFFFF'
            }
        },
        MuiSwitch: {
            colorSecondary: {
                "&$checked": {
                    color: 'blue'
                }
            },
            track: {
                // Controls default (unchecked) color for the track
                opacity: 0.2,
                backgroundColor: "#808080",
                "$checked$checked + &": {
                  // Controls checked color for the track
                  opacity: 0.7,
                  backgroundColor: "#808080"
                }
              }
        },
        MuiCssBaseline: {
            '@global': {
                  html: {
                    backgroundColor: '#eeeeee',
                    //WebkitFontSmoothing: 'auto',
                  },
            },
        },
        MuiDialog: {
            paper: {
                margin: 10,
                backgroundColor: '#606060'
            }
        },
        MuiButton: {
            textPrimary: {
                color: '#ffffff'
            },
            textSecondary: {
                color: '#eeeeee'
            }
        },
        MuiDrawer: {
            paper: {
                backgroundColor: '#404040'
            }
        }
    }
});
export default theme;